/** Page-root sx for standalone grid pages.
 *
 * The AppShell content area is a viewport-height flex column; rooting a page
 * with this sx propagates that height down so a `ResourceDataGrid` (default
 * `layout="fill"`) stretches to the remaining space and scrolls internally —
 * header, toolbar and pager stay visible, rows virtualize. Pages rooted in a
 * fragment get this for free (their children join the shell's flex column
 * directly); pages rooted in a `<Box>` opt in with `sx={PAGE_FILL_SX}`.
 * Detail/editor pages keep their plain roots and scroll normally.
 */
export const PAGE_FILL_SX = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
} as const;
